import { FC } from 'react'
import { HStack, ResponsiveValue,Stack, Text, useTheme, VStack } from '@chakra-ui/react'
import { VehicleType } from 'context/Vehicles'

import { CarIcon } from 'components/SVGS'

interface VehiclePlateInfoProps {
  flex?: number
  direction?: 'column' | 'row'
  isCarrouselItem?: boolean
  vehiclePlate?: string
  vehicle?: VehicleType
  paddingTop?: ResponsiveValue<string | number>
  height?: ResponsiveValue<string | number>
  isShortened?: boolean
  justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly'
}

export const VehiclePlateInfo: FC<VehiclePlateInfoProps> = ({
  flex = 1,
  direction = 'column',
  vehicle,
  vehiclePlate,
  paddingTop,
  height,
  justifyContent = 'flex-start',
  isShortened = false,
}) => {
  const {
    colors: {
      primaryColor: { text: { bgColorText, bgColorSecondaryText } },
    },
  } = useTheme()

  // Helper para acortar texto
  const shortenText = (text: string, maxLength: number) =>
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text

  return (
    <VStack
      flex={flex}
      height={height}
      alignItems="center"
      justifyContent={justifyContent}
      paddingTop={paddingTop}
      spacing={4}
    >
      <Stack direction={direction} justifyContent="center" alignItems="center" spacing={4}>
        {vehicle && (
            <HStack
            spacing={2}
            alignItems="center"
          >
            <CarIcon size={25} fill={bgColorText} />
            <Text
              variant="H2"
              color={bgColorText}
              textAlign="left"
              noOfLines={2}
            >
              {isShortened
                ? shortenText(vehicle.model.toUpperCase(), 7)
                : vehicle.model.toUpperCase()}
            </Text>
          </HStack>
        )}
        <HStack
          justifyContent="center"
          bgColor={bgColorText}
          borderRadius={20}
          px={4}
          py={2}
        >
          <Text
            variant="H2"
            color={bgColorSecondaryText}
            noOfLines={1}
            // maxFontSizeMultiplier={1}
          >
            {vehicle
              ? shortenText(vehicle.plateNumber.toUpperCase(), 7)
              : vehiclePlate?.toUpperCase()}
          </Text>
        </HStack>
      </Stack>
    </VStack>
  )
}
